import * as React from "react";
import { Dimmer, Button } from "semantic-ui-react";

interface IFallBackProps {}

/**
 * This is the visual aspect of the Error Boundary
 * It is what is rendered when an error is caught
 * @param props
 */
const FallBack: React.SFC<IFallBackProps> = props => (
	<Dimmer active>
		<h1>Oh no!</h1>
		<p>Something went wrong </p>
		<Button inverted onClick={() => window.location.reload(true)}>
			Refresh
		</Button>
		{/* {window && window.sessionStorage.getItem("errore") } */}
	</Dimmer>
);

export default FallBack;



// WEBPACK FOOTER //
// ./src/components/ErrorBoundary/Fallback.tsx